export function getMoreInfoItems(t, path) {
  const list = t(`${path}.items`, { returnObjects: true });
  return Array.isArray(list) && list.length > 0 ? list : [];
}
